import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";
import {
  hasAnalyticsConsent,
  loadGoogleAnalytics,
  trackWhatsAppConversion,
} from "@/utils/googleAnalytics";

function App() {
  useEffect(() => {
    if (hasAnalyticsConsent()) {
      loadGoogleAnalytics();
    }
  }, []);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const el = target?.closest?.("a[href], [data-whatsapp-cta]") as HTMLElement | null;
      if (!el) {
        return;
      }
      const href = (el.getAttribute("href") ?? "").toLowerCase();
      const isWhatsApp =
        el.hasAttribute("data-whatsapp-cta") ||
        href.indexOf("wa.me") !== -1 ||
        href.indexOf("whatsapp") !== -1;
      if (isWhatsApp) {
        trackWhatsAppConversion();
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <FloatingWhatsApp />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;